import translateLDSDestinations from "../services/translateLDSDestinations";
import { resolveOrganizedTourDestinationImage } from "./resolveOrganizedTourDestinationImage";
import { resolveOrganizedTourDateRange } from "./resolveOrganizedTourDateRange";
import { resolveOrganizedTourSearchDisplayNumber } from "./resolveOrganizedTourSearchDisplayNumber";
import { upgradeOrganizedTourRemoteImageUrl } from "./organizedTourHeroImageSsot";

function pickDealRoot(raw) {
  if (!raw || typeof raw !== "object") return null;
  return raw.fullDeal && typeof raw.fullDeal === "object" ? raw.fullDeal : raw;
}

function readTourCities(tour) {
  const val = tour?.tourCities?.val ?? tour?.tourCities;
  if (!val) return [];
  const codes = Array.isArray(val) ? val : [val];
  return codes
    .map((code) => {
      const rawCode = String(code || "").trim();
      if (!rawCode) return null;
      const t = translateLDSDestinations(rawCode);
      if (t && typeof t === "object") {
        return {
          code: rawCode,
          label: [t.COUNTRYNAME_HEB, t.CITYNAME_HEB].filter(Boolean).join(" — "),
        };
      }
      return { code: rawCode, label: rawCode };
    })
    .filter(Boolean);
}

/**
 * @param {unknown} raw — row from searchLds (OrganizedTour deal)
 */
export function normalizeOrganizedTourSearchResult(raw) {
  const deal = pickDealRoot(raw);
  const tour = deal?.tour || raw?.tour || {};
  const supplierId =
    deal?.supplierDetails?.supplierId ||
    raw?.supplierDetails?.supplierId ||
    "";
  const dateRange = resolveOrganizedTourDateRange(raw);
  const depDate = dateRange.depRaw || "";
  const retDate = dateRange.retRaw || "";
  const nights =
    tour?.nights ??
    deal?.nights ??
    null;
  const dealId = deal?.dealId || deal?.ldsDealId || raw?.dealId || "";
  const dealType = deal?.dealType || deal?.dealtype || "OrganizedTour";
  const displayMeta = resolveOrganizedTourSearchDisplayNumber(raw);
  const routeCities = readTourCities(tour);
  const routeLabel = routeCities.map((c) => c.label).join(" · ");
  const preNorm = {
    tourName: String(tour?.tourName || deal?.tourName || "טיול מאורגן"),
    routeLabel,
    routeCities,
  };
  const imageMeta = resolveOrganizedTourDestinationImage(raw, preNorm);
  const imageUrlRaw = imageMeta.resolvedImage || "";
  const imageUrl = imageUrlRaw
    ? upgradeOrganizedTourRemoteImageUrl(String(imageUrlRaw).trim())
    : "";
  const normalized = {
    dealId: String(dealId || ""),
    dealType,
    productType: "organized_tour",
    tourName: String(tour?.tourName || deal?.tourName || "טיול מאורגן"),
    routeCities,
    routeLabel,
    depDate: String(depDate || ""),
    retDate: String(retDate || ""),
    dateRange,
    depDateFormatted: dateRange.depFormatted,
    retDateFormatted: dateRange.retFormatted,
    dateRangeDisplay: dateRange.displayRange,
    dateRangeCompact: dateRange.displayCompact,
    depDateSource: dateRange.depSource,
    retDateSource: dateRange.retSource,
    nights: nights != null && nights !== "" ? Number(nights) : null,
    supplierId: String(supplierId || ""),
    isTransferIncluded:
      String(deal?.isTransferIncluded ?? raw?.isTransferIncluded ?? "") === "true",
    imageUrl: String(imageUrl || ""),
    displayOfferNumber: displayMeta.show ? displayMeta.value : "",
    displayOfferSource: displayMeta.source,
    imageSource: imageMeta.imageSource,
    raw,
    dealRoot: deal,
  };

  if (import.meta.env?.DEV) {
    console.log("[ORG_TOUR_RESULT_NORMALIZE]", {
      dealId: normalized.dealId,
      tourName: normalized.tourName,
      routeCount: normalized.routeCities.length,
      depDate: normalized.depDate,
      retDate: normalized.retDate,
      nights: normalized.nights,
      supplierId: normalized.supplierId,
    });
  }

  return normalized;
}
